import { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toSession } from "../auth/api";
import { useAuth } from "../auth/context";

export function AuthComplete() {
  const { state, setSession } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const access = params.get("access_token");
    const refresh = params.get("refresh_token");
    // Drop the fragment from the URL bar / history immediately so the tokens
    // don't sit in window.location for the rest of the session.
    history.replaceState(null, "", "/auth/complete");

    if (!access || !refresh) {
      navigate("/auth/error?reason=missing_tokens", { replace: true });
      return;
    }
    void (async () => {
      await setSession(toSession({ access_token: access, refresh_token: refresh }));
      navigate("/", { replace: true });
    })();
  }, [setSession, navigate]);

  if (state.status === "authenticated") return <Navigate to="/" replace />;

  return (
    <main className="mx-auto flex min-h-full max-w-md items-center justify-center p-8">
      <p className="text-sm text-slate-600 dark:text-slate-300">Signing you in…</p>
    </main>
  );
}
